module.exports = __webpack_public_path__ + "static/media/Logo-Fravents-blanco.982a6e5c.svg";